<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <TheCodeAdvisorTable />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CodigosAsesor",
  components: {
    TheCodeAdvisorTable: () =>
      import(
        "@/components/dashboardComponents/TheCodeAdvisorTable.vue"
      ),
  },
  data: () => ({
    page: {
      title: "Codigos de Asesor"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Codigos de Asesor",
        disabled: true,
        href: "/dashboard/advisorCodes/"
      }
    ]
  })
};
</script>
